import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-event',
    templateUrl: './event.component.html',
    styleUrls: ['./event.component.css'],
    standalone: false
})
export class EventComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
